import { inject, Injectable, signal } from '@angular/core';
import { BuilderContent, fetchEntries, fetchOneEntry } from '@builder.io/sdk-angular';
import { environment } from '@env/environment';
import { TranslateService } from '@ngx-translate/core';

@Injectable({
  providedIn: 'root',
})
export class BuilderService {
  translateService = inject(TranslateService);
  bannerContent = signal<BuilderContent | null>(null);
  homePurposeContent = signal<BuilderContent | null>(null);
  homeExpertiseContent = signal<BuilderContent | null>(null);
  homeProductCategoryContent = signal<BuilderContent | null>(null);

  fetchContent(urlPath: string, model: string): Promise<BuilderContent | null> {
    const currentLang = this.translateService.currentLang;
    const options = { locale: currentLang };
    const query = {
      data: {
        [`environment.${environment.env}`]: true,
      },
    };

    return fetchOneEntry({
      apiKey: environment.builderIoApiKey,
      model: model,
      userAttributes: { urlPath },
      query,
      options,
    });
  }

  fetchContentQuery(model: string, query: any): Promise<BuilderContent | null> {
    const currentLang = this.translateService.currentLang;
    const options = { locale: currentLang, noTargeting: false };

    return fetchOneEntry({
      apiKey: environment.builderIoApiKey,
      model: model,
      query,
      options,
    });
  }

  fetchData(model: string, options: any): Promise<BuilderContent[]> {
    const query = {
      data: {
        [`environment.${environment.env}`]: true,
      },
    };
    return fetchEntries({
      apiKey: environment.builderIoApiKey,
      model: model,
      options: options,
      query,
    });
  }
}
